import React from "react";
import StudentExamSummaryState, { StudentExamSummaryProps } from "./StudentExamSummary.models";
import './StudentExamSummary.scss';
import ExamSummary from "../exam-summary/ExamSummary";

export default class StudentExamSummary extends React.PureComponent<StudentExamSummaryProps, StudentExamSummaryState>{
    render(): React.ReactNode {

        return (<>
            <div className="dropdown-list student-exam-summary-area">
                <ExamSummary showOptions={true} examResultId={Number(this.props.examResultId)} />
            </div>
        </>);
    }

}